module.exports = __webpack_public_path__ + "static/media/2017 Camp.280508e0.jpg";